export { default } from './SecondaryGallery';
